module.exports = __webpack_public_path__ + "static/media/image_4.37cf549c.png";